/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DunningLevelSaveDto
 */
export interface DunningLevelSaveDto {
    /**
     * 
     * @type {string}
     * @memberof DunningLevelSaveDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DunningLevelSaveDto
     */
    description?: string;
}

/**
 * Check if a given object implements the DunningLevelSaveDto interface.
 */
export function instanceOfDunningLevelSaveDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function DunningLevelSaveDtoFromJSON(json: any): DunningLevelSaveDto {
    return DunningLevelSaveDtoFromJSONTyped(json, false);
}

export function DunningLevelSaveDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DunningLevelSaveDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function DunningLevelSaveDtoToJSON(value?: DunningLevelSaveDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
    };
}

